import React from 'react';
import Table from '../Table/Table';
import InfoTooltip from '../InfoTooltip/InfoTooltip';
import style from './ValuationAndMultiples.module.css';


const ValuationAndMultiples = ({ valuation = {}, stock }) => {
  const peRatioLink = stock?.symbol ? `/stocks/${stock.symbol.toLowerCase()}/pe-ratio` : null;
  const pegLink = stock?.symbol ? `/stocks/${stock.symbol.toLowerCase()}/peg` : null;
  const priceToSalesLink = stock?.symbol ? `/stocks/${stock.symbol.toLowerCase()}/price-to-sales` : null;
  const priceToBookLink = stock?.symbol ? `/stocks/${stock.symbol.toLowerCase()}/price-to-book` : null;
  const debtToEquityLink = stock?.symbol ? `/stocks/${stock.symbol.toLowerCase()}/debt-to-equity` : null;

  return (
    <div>
      <h3 className={style.headline}>Valuation & Multiples</h3>
      <div>
        <Table>
          <tbody>
            <tr className={peRatioLink ? style.clickableRow : undefined}>
              <th>
                {peRatioLink ? (
                  <a href={peRatioLink}>P/E Ratio</a>
                ) : (
                  'P/E Ratio'
                )}
              </th>
              <td className={style.points}>
                {peRatioLink ? (
                  <a href={peRatioLink} className={style.valueLink}>
                    <span>{valuation["pe_ratio"] ?? '-'}</span>
                    <img src="/react/phosphor/caret-right-bold.svg" alt="P/E Ratio" width="12" height="12" />
                  </a>
                ) : (
                  valuation["pe_ratio"] ?? '-'
                )}
              </td>
            </tr>
            <tr className={pegLink ? style.clickableRow : undefined}>
              <th>
                <InfoTooltip content="P/E ratio divided by expected earnings growth." label="PEG ratio definition">
                  {pegLink ? (
                    <a href={pegLink}>PEG</a>
                  ) : (
                    'PEG'
                  )}
                </InfoTooltip>
              </th>
              <td className={style.points}>
                {pegLink ? (
                  <a href={pegLink} className={style.valueLink}>
                    <span>{valuation["peg_ratio"] ?? '-'}</span>
                    <img src="/react/phosphor/caret-right-bold.svg" alt="PEG" width="12" height="12" />
                  </a>
                ) : (
                  valuation["peg_ratio"] ?? '-'
                )}
              </td>
            </tr>
            <tr className={priceToSalesLink ? style.clickableRow : undefined}>
              <th>
                {priceToSalesLink ? (
                  <a href={priceToSalesLink}>Price to Sales</a>
                ) : (
                  'Price to Sales'
                )}
              </th>
              <td className={style.points}>
                {priceToSalesLink ? (
                  <a href={priceToSalesLink} className={style.valueLink}>
                    <span>{valuation["price_to_sales"] ?? '-'}</span>
                    <img src="/react/phosphor/caret-right-bold.svg" alt="Price to Sales" width="12" height="12" />
                  </a>
                ) : (
                  valuation["price_to_sales"] ?? '-'
                )}
              </td>
            </tr>
            <tr className={priceToBookLink ? style.clickableRow : undefined}>
              <th>
                {priceToBookLink ? (
                  <a href={priceToBookLink}>Price to Book Ratio</a>
                ) : (
                  'Price to Book Ratio'
                )}
              </th>
              <td className={style.points}>
                {priceToBookLink ? (
                  <a href={priceToBookLink} className={style.valueLink}>
                    <span>{valuation["price_to_book"] ?? '-'}</span>
                    <img src="/react/phosphor/caret-right-bold.svg" alt="Price to Book Ratio" width="12" height="12" />
                  </a>
                ) : (
                  valuation["price_to_book"] ?? '-'
                )}
              </td>
            </tr>
            <tr>
              <th>Enterprise Value to Revenue</th>
              <td className={style.points}>{valuation["revenue_to_enterprise_value"] ?? '-'}</td>
            </tr>
            <tr>
              <th>Enterprise Value to EBIT</th>
              <td className={style.points}>{valuation["ebit_to_enterprise_value"] ?? '-'}</td>
            </tr>
            <tr>
              <th>Enterprise Value to Net Income</th>
              <td className={style.points}>{valuation["enterprise_value_to_net_income"] ?? '-'}</td>
            </tr>
            <tr>
              <th>
                <InfoTooltip content="Share of enterprise value that is debt." label="Total debt to enterprise value definition">
                  Total Debt to Enterprise
                </InfoTooltip>
              </th>
              <td className={style.points}>{valuation["total_debt_to_enterprise_value"] ?? '-'}</td>
            </tr>
            <tr className={debtToEquityLink ? style.clickableRow : undefined}>
              <th>
                {debtToEquityLink ? (
                  <a href={debtToEquityLink}>Debt to Equity</a>
                ) : (
                  'Debt to Equity'
                )}
              </th>
              <td className={style.points}>
                {debtToEquityLink ? (
                  <a href={debtToEquityLink} className={style.valueLink}>
                    <span>{valuation["debt_to_equity"] ?? '-'}</span>
                    <img src="/react/phosphor/caret-right-bold.svg" alt="Debt to Equity" width="12" height="12" />
                  </a>
                ) : (
                  valuation["debt_to_equity"] ?? '-'
                )}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default ValuationAndMultiples;
